import { render } from "./TextModal.vue?vue&type=template&id=1d0c4bcb"
import script from "./TextModal.vue?vue&type=script&lang=js"
export * from "./TextModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/dlr-pt/rote-liste-zentrum/prj-moose_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__